import { CustomForm, CustomFormGroup } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { ProvValidator } from "@tilby/tilby-ui-lib/utilities";
import { Categories } from "tilby-models";

export class CategoriesFe implements Categories {
    id = 0;
    name = '';
    uuid = '';
    department_id = 0;
    department2_id = 0;
    department3_id = 0;
    department4_id = 0;
    department5_id = 0;
    department6_id = 0;
    department7_id = 0;
    department8_id = 0;
    department9_id = 0;
    department10_id = 0;
    department_name = '';
    department2_name = '';
    department3_name = '';
    department4_name = '';
    department5_name = '';
    department6_name = '';
    department7_name = '';
    department8_name = '';
    department9_name = '';
    department10_name = '';
    printer_id = 0;
    printer_name = '';
    terminal_id = '';
    terminal_name = '';
    display = false;
    display_kiosk = false;
    display_slave_device = false;
}

export type CategoriesFields = Categories;

export type CategoriesFieldsNullable = { [prop in string & keyof CategoriesFields]: CategoriesFields[prop] | null };
export type CategoriesForm = Partial<CustomForm<CategoriesFieldsNullable>>;

export type CategoriesFormGroups = CustomFormGroup<CategoriesForm>;

export interface CategoriesValidators extends ProvValidator {
    nameMaxLength: number;
    scaleCategoryMin: number;
    scaleCategoryMax: number;
}

export const filterableCategoriesColumnsWithSearchBar: (keyof CategoriesFe)[] = ["name"];